import type { iProcess } from '../components/type';
import type { RecentCollectCollectionSummary } from '../services/api/collectDataService';
import { getProcessModifiedTimestamp } from './formatDate';

export type HomeRecentMergedKind = 'process' | 'dataCollect';

export type HomeRecentMergedEntry =
    | { kind: 'process'; item: iProcess; sortKey: number }
    | { kind: 'dataCollect'; item: RecentCollectCollectionSummary; sortKey: number };

function parseSortTs(value: unknown): number {
    if (value == null || value === '') return 0;
    if (typeof value === 'number' && Number.isFinite(value)) return value;
    const d = new Date(value as string);
    const n = d.getTime();
    return Number.isFinite(n) ? n : 0;
}

/**
 * Fusionne processus et collectes data, tri par dernière activité (updated puis created) décroissant.
 */
export function mergeProcessesAndDataCollections(
    processes: iProcess[],
    collections: RecentCollectCollectionSummary[],
): HomeRecentMergedEntry[] {
    const out: HomeRecentMergedEntry[] = [];
    for (const p of processes) {
        const raw = getProcessModifiedTimestamp(p as unknown as Record<string, unknown>);
        out.push({ kind: 'process', item: p, sortKey: parseSortTs(raw) });
    }
    for (const c of collections) {
        const ts = parseSortTs(c.updated_at ?? c.created_at);
        out.push({ kind: 'dataCollect', item: c, sortKey: ts });
    }
    out.sort((a, b) => b.sortKey - a.sortKey);
    return out;
}
